import axios from 'axios';

const baseUrl = id => `/api/v1/wire/${id}/bookmark`;

export function bookmark(wireId) {
  return axios.post(baseUrl(wireId));
}

export function unbookmark(wireId) {
  return axios.delete(baseUrl(wireId));
}
